import { SxProps } from '@mui/material';

export const DpFanFinishCouponFrameSx: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	width: '100%',
	gap: { xs: '27px', md: '30px' },
};

export const DpFanFinishCouponDataSx: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	maxWidth: { xs: '100%', md: '720px' },
	width: '100%',
};

export const DpFanFinishCouponTitleSx: SxProps = {
	color: '#2C2C2C',
	fontSize: { xs: '20px', md: '36px' },
	fontWeight: '800',
	textAlign: 'center',
	marginTop: '15px',
	marginBottom: '10px',
};

export const DpFanFinishCouponMessageSx: SxProps = {
	color: '#2C2C2C',
	fontSize: { xs: '18px', md: '20px' },
	textAlign: 'center',
};

export const DpFanFinishCouponCodeWrapperSx: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: '12px',
	width: '100%',
};

export const DpFanFinishCouponCodeFrameSx: SxProps = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: '12px',
	padding: '8px 32px',
	borderRadius: '999px',
	border: '1.5px dashed #0F4BDB',
	backgroundColor: '#EAF1FF',
};

export const DpFanFinishCouponCodeLabelSx: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	lineHeight: 1.1,
};

export const DpFanFinishCouponCodeTitleSx: SxProps = {
	color: '#2C2C2C',
	fontSize: '11px',
	fontWeight: 700,
	letterSpacing: '0.5px',
};

export const DpFanFinishCouponCodeSx: SxProps = {
	color: '#0F4BDB',
	fontSize: { xs: '20px', md: '22px' },
	fontWeight: 800,
	letterSpacing: '1px',
};

export const DpFanFinishCouponCopySx: SxProps = {
	color: '#333333',
	padding: '4px',
	'& .MuiSvgIcon-root': {
		fontSize: '20px',
	},
};

export const DpFanFinishCouponDisclaimerSx: SxProps = {
	color: '#6B6B6B',
	fontSize: '12px',
	textAlign: 'center',
	maxWidth: '380px',
};

export const DpFanFinishCouponButtonFrameSx: SxProps = {
	display: 'flex',
	gap: '16px',
	width: '100%',
	justifyContent: { xs: undefined, md: 'center' },
};

export const DpFanFinishCouponButtonSx: SxProps = {
	maxWidth: { xs: '100%', md: '374px' },
};
